const eventHub = {
  install: function (Vue, _options) {
    const main = new Vue()
    window.addEventListener('popstate', function (e) {
      console.info(e)
      main.$emit('popstate')
    })
    Vue.prototype.$eventHub = main
  }
}
export default eventHub
